<template>
	<app-page>
		<app-heading title="API Keys">
			<template v-slot:left>
				<app-button v-if="$ravello.can('api.post')"
					class="d-none d-sm-inline-flex"
					color="success"
					small
					outlined
					:to="{ name: 'api-key', params: { key: 'generate' } }"
				>Generate Key</app-button>
			</template>
		</app-heading>
		<app-row>
			<app-cell>
				<app-data-table
					:items="keys"
					:headers="headers"
					:total="count"
					:refresh.sync="refresh"
					@update="fetchKeys"
				>
					<template v-slot:actions="{ item }">
						<app-button
							v-if="$ravello.can('api.put')"
							color="secondary"
							icon="fa-pencil-alt"
							table
							:to="{ name: 'api-key', params: { key: item._id } }"
						>
							Edit
						</app-button>
						<app-button-confirm
							v-if="$ravello.can('api.delete')"
							color="error"
							icon="fa-ban"
							table
							label-confirm="Revoke"
							:description="`Are you sure you want to revoke API key <b>${item.name || item.key}</b>?`"
							title="Revoke Key"
							@click="onDelete(item._id)"
						>
							Revoke
						</app-button-confirm>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
		<app-floating-button
			class="d-inline-flex d-sm-none"
			:to="{ name: 'api-key', params: { key: 'generate' } }"
			color="success"
			icon="fa-plus"
		/>
	</app-page>
</template>

<script>
export default {
	data() {
		return {
			keys: [],
			count: -1,
			refresh: false,
			headers: [{
				text: 'Name',
				value: 'name',
				sortable: true,
			}, {
				text: 'Key',
				value: 'key',
				sortable: true,
			}, {
				text: 'Role',
				value: 'role.name',
				sortable: false,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
		}
	},
	methods: {
		async fetchKeys(pagination) {
			const request = this.$ravello.graphql('apikeys')
				.fields(['_id', 'name', 'key'])
				.include(this.$ravello.graphql('role').field('name'))
				.fromPagination(pagination)

			if (this.count === -1) {
				request.count('count')
			}
			try {
				this.keys = await request.query()
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				if (err.data.errors) {
					err.data.errors.forEach(error => this.$notifications.pushAlert('error', error.message))
				} else {
					this.$notifications.pushAlert('error', err.message)
				}
			}
		},
		async onDelete(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.to('apikeys')
					.to(id)
					.delete()
				this.refresh = true
				this.$notifications.pushAlert('success', 'API key successfully revoked')
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},
	},
}
</script>
